// col 最小百分比宽度
export const CELL_MIN_PRE = 3;
// col 最小 px 宽度
export const CELL_MIN_WIDTH = 26;
